import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type ReferringUnitInputFields = {
  referringUnit: string;
};

const ReferringUnitInput = ({
  referringUnitFieldConfig,
}: {
  referringUnitFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<ReferringUnitInputFields>();

  return (
    <InputField
      type="text"
      {...register("referringUnit", {
        required: {
          value:
            referringUnitFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange remitterande enhet`,
        },
      })}
      label={t`Remitterande enhet`}
      showOptionalLabel={
        referringUnitFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.referringUnit?.message}
    />
  );
};

export default ReferringUnitInput;
